import type { StyleProfile, StyleRule } from '@worldathletics/types';

export function resolveStyleRule(
  profile: StyleProfile | null | undefined,
  style: string,
  depth: number,
): StyleRule | null {
  if (!profile?.rules) return null;
  return (
    profile.rules[`${style}@${String(depth)}`] ??
    profile.rules[style] ??
    profile.rules['_default'] ??
    null
  );
}
